import ContactUsSectionT from '@factories/RowFactory/components/ContactUsSection/types';
import { StyledContactUsSection } from '@factories/RowFactory/components/ContactUsSection/styled/StyledContactUsSection';
import React from 'react';
import { DynamicIcon } from '@components/Atoms/Icon/Icon';

export const ContactUsSection = ({ display, title, items }: ContactUsSectionT) => {
  if (!display) return null;

  return (
    <StyledContactUsSection className="container">
      <h2>{title}</h2>
      <div className="items-container">
        {items.map((item, index) => (
          <div key={`contact-us-item-${index}`} className="item">
            <DynamicIcon icon={`${item.method}_Circle`} height={'56px'} width={'56px'} />
            <div className="item-text">
              <p className="info">{item.info}</p>
              <p className="extra-info">{item.extraInfo}</p>
            </div>
            <p></p>
          </div>
        ))}
      </div>
    </StyledContactUsSection>
  );
};
